const avatarColors = [
  "#17B2EB", // Soterix Blue
  "#00BFA5", // Teal
  "#E91E63", // Pink
  "#9C27B0", // Purple
  "#673AB7", // Deep Purple
  "#3F51B5", // Indigo
  "#2196F3", // Blue
  "#00BCD4", // Cyan
  "#4CAF50", // Green
  "#FF9800", // Orange
  "#FF5722", // Deep Orange
  "#F44336", // Red
];

export const stringToColor = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return avatarColors[Math.abs(hash) % avatarColors.length];
};
